import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setUsersAdminFilter } from '../../Redux/actions/usersAdminFilterActions'
import { Search, X, Check } from 'lucide-react'
import { translations } from '../../utils/constants'
import { setUserCount } from '../../Redux/actions/userAction'

const SearchDeviceUser = ({ selectedUsers, handleUserChange, users, setSearchUserModal, searchUserModal, language }) => {
    const [searchQuery, setSearchQuery] = useState('')
    const dispatch = useDispatch()
    const selectedUsrs = useSelector(state => state.usersAdminFilterReducer?.usersAdminFilter || [])
    const modalRef = useRef(null)

    useEffect(() => {
        dispatch(setUserCount(selectedUsrs?.length || 0))
    }, [selectedUsrs, dispatch])

    useEffect(() => {
        if (!searchUserModal) {
            setSearchQuery('')
        }
    }, [searchUserModal])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setSearchUserModal(false)
            }
        }
        if (searchUserModal) {
            document.addEventListener('mousedown', handleClickOutside)
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [searchUserModal, setSearchUserModal])

    const filteredUsers = users.filter((user) =>
        user?.user_name?.toLowerCase()?.includes(searchQuery.toLowerCase())
    )

    const handleUserSelection = (userId) => {
        const isSelected = selectedUsrs?.includes(userId)
        let updatedUsers = isSelected
            ? selectedUsrs?.filter(id => id !== userId)
            : [...selectedUsrs, userId]

        dispatch(setUsersAdminFilter(updatedUsers))
        handleUserChange?.(updatedUsers)
    }

    const handleSelectAll = () => {
        if (selectedUsrs?.length > 1) { 
            dispatch(setUsersAdminFilter([]))
            handleUserChange?.([])
        } else {
            const allUserIds = users?.map(user => user?.id)
            dispatch(setUsersAdminFilter(allUserIds || []))
            handleUserChange?.(allUserIds || [])
        }
    }

    return (
        <div className="search-organization-container" ref={modalRef}>
            <span className="close-icon-search" onClick={() => setSearchUserModal(false)}><X /></span>

            <div className='search-organization-header'>
                <h1>{translations[language]?.users}</h1>
            </div>

            <div className="search-inner-div search-input-div2" style={{ margin: '0px' }}>
                <Search className="search-icon" />
                <input
                    type="text"
                    placeholder={translations[language]?.searchUsers}
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="search-input"
                />
            </div>

            <div className='organizations-header'>
                <div className='organization-search-text'>{translations[language]?.users}</div>
                <div onClick={handleSelectAll} className="select-all-button">
                    {selectedUsrs?.length > 1 ? translations[language]?.clearAll : translations[language]?.selectAll}
                </div>
            </div>

            <div className='organizations-list-div'>
                <div className="organizations-list">
                    {filteredUsers?.map((user) => (
                        <div
                            key={user.id}
                            onClick={() => handleUserSelection(user.id)}
                            className={`organization-item ${selectedUsrs?.includes(user.id) ? 'selected' : ''}`}
                        >
                            <div className="checkbox">
                                {selectedUsrs?.includes(user.id) && <Check className="check-icon" />}
                            </div>

                            <div className="organization-info">
                                <div className="user-search-logo">
                                    {user?.user_name ? user?.user_name.charAt(0).toUpperCase() : "U"}
                                </div>

                                <div>
                                    <div className="organization-name capitalized-name">
                                        {user?.user_name}
                                    </div>
                                    <div className="organization-users">
                                        {user?.total_devices} {translations[language]?.devices}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {filteredUsers?.length === 0 && (
                    <div className="no-results">
                        {translations[language]?.noUserFound}
                    </div>
                )}
            </div>
        </div>
    )
}

export default SearchDeviceUser